import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuthStore from "../../stores/useAuthStore";
import LoadingSpinner from "../ui/LoadingSpinner";

const ProtectedRoute = () => {
  const { user, loading, checkAuth } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    if (!user && loading) {
      checkAuth();
    }
  }, [user, loading, checkAuth]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!user) {
    const redirect = location.pathname + location.search;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
